/// <amd-module name="Build/Admin/Agent/Actions/ActionsHub" />
import { Action } from "VSS/Reflux/Action";

import { TaskAgent, TaskAgentPool, TaskAgentQueue } from "DistributedTask/Client/Contracts/TaskAgent";

import { ConfirmationDialogActions } from "Build/Admin/Common/Actions/ConfirmationDialogActions";
import { JobActions } from "Build/Admin/Common/Actions/JobActions";
import { NotificationActions } from "Build/Admin/Common/Actions/NotificationActions";
import { ProjectActions } from "Build/Admin/Common/Actions/ProjectActions";
import { SignalRActions } from "Build/Admin/Common/Actions/SignalRActions";

export class ActionsHub {
    public confirmationDialogActions = new ConfirmationDialogActions<string>();
    public jobActions = new JobActions();
    public notificationActions = new NotificationActions();
    public projectActions = new ProjectActions();
    public signalRActions = new SignalRActions();

    public dismissAddUserCapabilityPanel = new Action<void>();
    public selectedAgentUpdated = new Action<TaskAgent | undefined>();
    public selectedAgentQueueUpdated = new Action<TaskAgentQueue | undefined>();
    public selectedAgentPoolUpdated = new Action<TaskAgentPool | undefined>();
    public selectedTabUpdated = new Action<string>();
    public showAddUserCapabilityPanel = new Action<void>();
}
